import { useTranslation } from 'react-i18next';
import React, { useRef, useEffect } from 'react'
import YHDrawer from '@/erp_subpackage/components/YhDrawer'
import { YhForm } from '@/erp_subpackage/components/YhFormBox'
// import { getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { Button, Form, message, Upload } from 'antd'
import { useLockFn } from 'ahooks'
import { creditFlagDs } from '@/erp_subpackage/utils/ErpEnum'
import { getBentityListOption } from '@/utils/dataStorage'
import FontIcon from '@/erp_subpackage/components/YhIcon'
import { getBaseImgUploadUrl, getBaseUploadData } from '@/config/app'
import { commonService } from '@/erp_subpackage/pages/common/commonService'
import { trasDsToTreeData } from '@/erp_subpackage/utils/util'
import { useState } from 'react'

export const YhFmsAddRecharge = ({ visible, setVisible, addRechargeData: selectedData, queryAccountCustomer, onSucess }) => {
    const { t } = useTranslation()
    let [treeData, setTreeData] = useState([])

    useEffect(() => {
        if (visible) {

            getTreeData()
        }
    }, [visible])

    const getTreeData = async () => {
        let data = await commonService.fmsDictAllTree({ code: 'pay-method' })
        setTreeData(trasDsToTreeData(data.retData[0].children, 'code', 'name'))
    }

    const formRef = useRef()
    const normFile = (e) => {
        let filetypes = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        let isType = false
        let fileEnd = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        isType = filetypes?.includes(fileEnd) ?? false
        console.log('Upload event:', e)
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                // e.fileList = [data]
                e.fileList[e.fileList.length - 1] = data
            } else {
                message.error(t(`erpcomponents.YhFmsAddRecharge.index.文件上传失败，请重新上传`))
            }
        }
        if (e.file.status === 'error') {
            message.error(t(`erpcomponents.YhFmsAddRecharge.index.文件上传失败，请重新上传`))
        }
        if (Array.isArray(e)) {
            return e
        }
        if (!isType) {
        }
        return e && e.fileList
    }
    const formConfig = {
        formRef,
        labelCol: { span: 6 },
        disabled: false,
        formValues: { ...selectedData, ...queryAccountCustomer },
        items: [
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.客户`),
                fieldName: 'code',
                disable: true,
                span: 24,
            },
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.账户`),
                fieldName: 'name',
                disable: true,
                span: 24,
            },
            {
                type: 'Select',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.授信类型`),
                fieldName: 'creditFlag',
                disable: true,
                span: 24,
                options: creditFlagDs,
            },
            // {
            //     type: FormItemTypeEnum.TreeSelect,
            //     fieldLabel: "机构",
            //     fieldName: "orgCode",
            //     disable: true,
            //     span: 24,
            //     treeDs: orgDs
            // },
            {
                type: 'Select',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.实体`),
                fieldName: 'beCode',
                disable: true,
                span: 24,
                options: getBentityListOption(),
            },
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.剩余金额`),
                fieldName: 'remainingAmount',
                disable: true,
                span: 24,
            },
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.充值金额`),
                fieldName: 'rechargeAmount',
                span: 24,
                rules: [
                    {
                        required: true,
                        pattern: new RegExp(/^[+|-]?(\d+)$|^[+|-]?(\d+\.\d+)$/),
                        message: t(`erpcomponents.YhFmsAddRecharge.index.请输入数字`),
                    },
                ],
            },
            {
                type: 'TreeSelect',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.支付方式`),
                fieldName: 'payMethodCode',
                span: 24,
                treeData: treeData,
                rules: [
                    {
                        required: true,
                        message: t(`erpcomponents.YhFmsAddRecharge.index.授信类型不能为空`),
                    },
                ],
            },
            {
                type: 'Other',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.附件`),
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item
                        name="fileList"
                        label={t(`erpcomponents.YhFmsAddRecharge.index.附件`)}
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[
                            {
                                required: true,
                                message: t(`erpcomponents.YhFmsAddRecharge.index.请上传附件信息`),
                            },
                        ]}
                    >
                        <Upload
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            // headers={{
                            //     authorization: getToken()
                            // }}
                            listType="picture"
                            maxCount={1}
                            // disabled={editModel === 'look'}
                            beforeUpload={(file) => {
                                let fileEnd = file.name.substring(file.name.lastIndexOf('.'))
                                // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let filetypes = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
                                // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    message.error(t(`erpcomponents.YhFmsAddRecharge.index.不支持该格式的上传,当前仅支持图片、pdf和.doc类型文件`))
                                }
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error(t(`erpcomponents.YhFmsAddRecharge.index.上传到文件不能超过`) + '20M')
                                    file.status = 'done'
                                }
                                return isType && isLt20M
                            }}
                            iconRender={(file) => {
                                if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                                if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            }}
                        >
                            <Button> {t(`erpcomponents.YhFmsAddRecharge.index.选择文件上传`)}</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.收款人`),
                fieldName: 'operator',
                span: 24,
            },
            {
                type: 'Input',
                fieldLabel: t(`erpcomponents.YhFmsAddRecharge.index.备注`),
                fieldName: 'remark',
                span: 24,
            },
        ],
    }

    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields()
            if (formData) {
                const { fileList = [], ...params } = formData
                const reqData = {
                    ...params,
                    accountCode: formData.code,
                    partnerTypeCode: 'user-type.customer',
                    partnerCode: selectedData.code,
                    note: formData.remark,
                }
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        console.log(file)
                        return message.error(t(`erpcomponents.YhFmsAddRecharge.index.文件信息有误，请重新上传文件`))
                    }
                    if (file?.status) {
                        console.log(file)
                        return message.warn(t(`erpcomponents.YhFmsAddRecharge.index.文件正在上传，请等待文件上传成功`))
                    }
                    reqData.md5 = file?.uid
                    reqData.fileName = file.name
                    reqData.fileSize = file.size
                }
                let insertRet = await commonService.fmsRecharge(reqData);
                if (insertRet.success) {
                    message.success(t(`erpcomponents.YhFmsAddRecharge.index.充值申请成功`));
                    setVisible(false);
                    onSucess && onSucess()
                } else {
                    message.error(t(`erpcomponents.YhFmsAddRecharge.index.充值失败`) + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log(t(`erpcomponents.YhFmsAddRecharge.index.数据校验失败`), e)
        }
    })
    const onClose = () => {
        setVisible(false)
    }

    return (
        <YHDrawer
            {...{
                title: t(`erpcomponents.YhFmsAddRecharge.index.账户充值`),
                visible: visible,
                onOk,
                onClose,
                showFooter: true,
                style: { top: 0 },
                width: 500,
            }}
        >
            <div style={{ padding: '20px' }}>
                <YhForm {...formConfig}></YhForm>
            </div>
        </YHDrawer>
    )
}
